<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    :title="`${!address ? '新增' : '修改'}收货地址`"
    width="500px"
    :height="310"
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
    class="c-PickupAddress-sns"
  >
    <div>
      <el-row>
        <znl-input
          title="收货人姓名:"
          width="100%"
          title-width="80px"
          :border="true"
          v-model="addressInfo.UserContactName"
        ></znl-input>
      </el-row>
      <el-row>
        <znl-input
          title="电话号码:"
          width="100%"
          title-width="80px"
          :border="true"
          v-model="addressInfo.UserContactPhone"
        ></znl-input>
      </el-row>
      <el-row class="multiple-inputs">
        <znl-input
          :border="true"
          title="地址信息:"
          title-width="80px"
          width="200px"
          form-type="select"
          :select-options="provinces"
          v-model="addressInfo.Province"
          @change="addressInfo.City = ''; addressInfo.County = ''"
        ></znl-input>

        <znl-input
          :border="true"
          title-width="80px"
          width="120px"
          form-type="select"
          :select-options="cities"
          v-model="addressInfo.City"
          @change="addressInfo.County = ''"
        ></znl-input>

        <znl-input
          :border="true"
          title-width="80px"
          width="120px"
          form-type="select"
          :select-options="counties"
          v-model="addressInfo.County"
        ></znl-input>
      </el-row>
      <el-row>
        <znl-input
          title="详细地址:"
          width="100%"
          title-width="80px"
          :border="true"
          type="textarea"
          v-model="addressInfo.Detailed"
        ></znl-input>
      </el-row>
    </div>
    <div class="IsDefault-row">
      <el-checkbox v-model="addressInfo.IsDefault">设置为默认收货地址</el-checkbox>
    </div>

    <div slot="footer">
      <znl-button
        :width="60"
        :height="30"
        @click="$emit('update:visible', false)"
      >取消</znl-button>
      <znl-button
        :width="60"
        :height="30"
        style-type="main"
        class="ml10"
        @click="addUpdateUserContact"
      >保存</znl-button>
    </div>
  </znl-dialog>
</template>
<script>
import { ChinaProvinceCity } from '../../assets/scripts/China_Province_City';
import { httpPost } from '../../assets/scripts/http';

export default {
  name: 'PickupAddress',

  props: {
    visible: Boolean,
    address: Object,
    getUserContacts: Function
  },

  computed: {
    provinces() {
      return ChinaProvinceCity.map(item => {
        return {
          key: item.name,
          value: item.name
        };
      });
    },
    cities() {
      const ProvinceInfo = ChinaProvinceCity.find(item => {
        return item.name === this.addressInfo.Province;
      });
      if (ProvinceInfo) {
        return ProvinceInfo.cityList.map(item => {
          return {
            key: item.name,
            value: item.name
          };
        });
      }
      return [];
    },
    counties() {
      const ProvinceInfo = ChinaProvinceCity.find(item => {
        return item.name === this.addressInfo.Province;
      });
      let cityInfo = null;
      if (ProvinceInfo) {
        cityInfo = ProvinceInfo.cityList.find(item => {
          return item.name === this.addressInfo.City;
        });
      }
      if (cityInfo) {
        return cityInfo.areaList.map(item => {
          return {
            key: item.name,
            value: item.name
          };
        });
      }
      return [];
    }
  },

  data() {
    return {
      addressInfo: {
        IsDefault: false,
        Province: '',
        City: '',
        County: '',
        UserContactName: '',
        UserContactPhone: '',
        Detailed: ''
      }
    };
  },

  watch: {
    visible(val) {
      if (val && this.address) {
        this.addressInfo = Object.assign({}, this.address);
      }
      if (!val) {
        this.addressInfo = {
          IsDefault: false,
          Province: '',
          City: '',
          County: '',
          UserContactName: '',
          UserContactPhone: '',
          Detailed: ''
        };
      }
    }
  },

  methods: {
    addUpdateUserContact() {
      httpPost('bomorder/addUpdateUserContact', this.addressInfo).then(res => {
        if (res.Code === 0) {
          this.$succMess('设置成功');
          this.$emit('update:visible', false);
          if (this.getUserContacts) {
            this.getUserContacts();
          }
        } else {
          this.$erroMess(res.Message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.c-PickupAddress-sns {
  .el-row {
    line-height: 40px;
    &:last-child {
      margin-top: 6px;
    }
  }
  .IsDefault-row {
    line-height: 30px;
    padding-left: 80px;
    box-sizing: border-box;
  }
  .multiple-inputs {
    .znl-component-input {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>